// src/Redux/Thunks/backlogThunk.js

import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../Services/ApiBase";
import { API_ENDPOINTS } from "../../Services/ApiEndPoints";
import { getApiErrorMessage } from "../../utils/apiErrorMessage";
import { mapWorkItemsListResponse } from "../../Pages/Projects/projectMappers";

/** Legacy string arg: one page, larger limit (project backlog tab). */
const DEFAULT_LIMIT_PROJECT = 100;
/** Paginated backlog (e.g. Issues Kanban sidebar). */
const DEFAULT_LIMIT_PAGED = 10;

/**
 * Fetch backlog — GET /backlog
 * - Global: `fetchBacklogData({ page: 1, limit: 10 })` → `?page=&limit=` (no projectId)
 * - Project: `fetchBacklogData(projectId)` or `{ projectId, page, limit }`
 * Response: `{ data: { data: WorkItem[], meta } }` (same shape as work items).
 */
export const fetchBacklogData = createAsyncThunk(
  "backlog/fetchData",
  async (arg, { rejectWithValue }) => {
    try {
      if (typeof arg === "string") {
        const id = arg != null && String(arg).trim() !== "" ? String(arg).trim() : "";
        if (!id) {
          return rejectWithValue("Project is required to load backlog.");
        }
        const response = await get(API_ENDPOINTS.BACKLOG.GET_ALL, {
          projectId: id,
          page: 1,
          limit: DEFAULT_LIMIT_PROJECT,
        });
        return mapWorkItemsListResponse(response.data);
      }

      const params = arg && typeof arg === "object" ? arg : {};
      const projectId =
        params.projectId != null && String(params.projectId).trim() !== ""
          ? String(params.projectId).trim()
          : "";
      const page = Number(params.page) > 0 ? Number(params.page) : 1;
      const limitRaw = Number(params.limit);
      const limit =
        limitRaw > 0 ? limitRaw : projectId ? DEFAULT_LIMIT_PROJECT : DEFAULT_LIMIT_PAGED;

      const query = { page, limit };
      if (projectId) query.projectId = projectId;

      const response = await get(API_ENDPOINTS.BACKLOG.GET_ALL, query);
      return mapWorkItemsListResponse(response.data);
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to fetch backlog data"));
    }
  }
);
